module.exports = __webpack_public_path__ + "img/bus-empty.ea0047a3.svg";